import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ConstructionAgreementInfoResponse } from '@/types/api/mypage/constructionAgreementInfo';

/** 工事承諾情報取得APIのURL */
const url = ApiUrl.Read.CONSTRUCTION_AGREEMENT_INFO;

/**
 * 工事承諾情報取得APIの呼び出しフック。
 * 工事前後の確認事項を表示するための承諾情報を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetConstructionAgreementInfo = () => {
  const execute = useCallback(async (): Promise<
    AxiosResponse<ConstructionAgreementInfoResponse>
  > => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetConstructionAgreementInfo;
